/**
 * @file Holds the instance for making the API call to get the marking preference settings
 */

import defaultDeep from 'lodash/defaultsDeep';
import BaseConfig from './http.base-instance-config';

import { getAppVariable } from '@white-label-helper/get-app-variable';

const options = defaultDeep({
  baseURL: process.env['NUXT_ENV_MARKETING_API_URL'],
  headers: {
    Authorization: `Bearer ${getAppVariable('channel.token')}`,
  },
}, BaseConfig.options);

export default {
  interceptors: BaseConfig.interceptors,
  options,
};
